"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentSubscriptionsImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing DocumentSubscriptions operations. */
var DocumentSubscriptionsImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class DocumentSubscriptions class.
   * @param client Reference to the service client
   */
  function DocumentSubscriptionsImpl(client) {
    (0, _classCallCheck2["default"])(this, DocumentSubscriptionsImpl);
    this.client = client;
  }
  /**
   *  (Auth: Authorize)
   * @param portalId
   * @param subscriptionName
   * @param body Anything
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(DocumentSubscriptionsImpl, [{
    key: "createOrUpdateSubscription",
    value: function createOrUpdateSubscription(portalId, subscriptionName, body, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionName: subscriptionName,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, createOrUpdateSubscriptionOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionName
     * @param options The options parameters.
     */

  }, {
    key: "deleteSubscription",
    value: function deleteSubscription(portalId, subscriptionName, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionName: subscriptionName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteSubscriptionOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getAllSubscriptions",
    value: function getAllSubscriptions(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAllSubscriptionsOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionName
     * @param fieldsetName
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentSubscriptionDocuments",
    value: function getDocumentSubscriptionDocuments(portalId, subscriptionName, fieldsetName, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionName: subscriptionName,
        fieldsetName: fieldsetName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentSubscriptionDocumentsOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionName
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentSubscriptionsDocumentsDelta",
    value: function getDocumentSubscriptionsDocumentsDelta(portalId, subscriptionName, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionName: subscriptionName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentSubscriptionsDocumentsDeltaOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionName
     * @param options The options parameters.
     */

  }, {
    key: "addDocumentSubscriptionMark",
    value: function addDocumentSubscriptionMark(portalId, subscriptionName, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionName: subscriptionName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, addDocumentSubscriptionMarkOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionName
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentSubscriptionMarks",
    value: function getDocumentSubscriptionMarks(portalId, subscriptionName, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionName: subscriptionName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentSubscriptionMarksOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionName
     * @param options The options parameters.
     */

  }, {
    key: "deleteAllDocumentSubscriptionMarks",
    value: function deleteAllDocumentSubscriptionMarks(portalId, subscriptionName, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionName: subscriptionName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteAllDocumentSubscriptionMarksOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionName
     * @param markId
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentSubscriptionMark",
    value: function getDocumentSubscriptionMark(portalId, subscriptionName, markId, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionName: subscriptionName,
        markId: markId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentSubscriptionMarkOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionName
     * @param markId
     * @param options The options parameters.
     */

  }, {
    key: "deleteDocumentSubscriptionMark",
    value: function deleteDocumentSubscriptionMark(portalId, subscriptionName, markId, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionName: subscriptionName,
        markId: markId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteDocumentSubscriptionMarkOperationSpec);
    }
  }]);
  return DocumentSubscriptionsImpl;
}(); // Operation Specifications


exports.DocumentSubscriptionsImpl = DocumentSubscriptionsImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var createOrUpdateSubscriptionOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions/{subscriptionName}",
  httpMethod: "PUT",
  responses: {
    200: {},
    400: {},
    401: {},
    403: {},
    404: {},
    409: {}
  },
  requestBody: Parameters.body17,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionName],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var deleteSubscriptionOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions/{subscriptionName}",
  httpMethod: "DELETE",
  responses: {
    200: {},
    400: {},
    401: {},
    403: {},
    404: {},
    410: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionName],
  serializer: serializer
};
var getAllSubscriptionsOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSubscriptionModel"
            }
          }
        }
      }
    },
    400: {},
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentSubscriptionDocumentsOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions/{subscriptionName}/documents",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Dictionary",
              value: {
                type: {
                  name: "any"
                }
              }
            }
          }
        }
      }
    },
    400: {},
    401: {},
    403: {},
    404: {}
  },
  queryParameters: [Parameters.fieldsetName],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentSubscriptionsDocumentsDeltaOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions/{subscriptionName}/marksDelta",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentSubscriptionMarksDelta
    },
    400: {},
    401: {},
    403: {},
    404: {}
  },
  queryParameters: [Parameters.firstMarkId, Parameters.secondMarkId, Parameters.changes],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var addDocumentSubscriptionMarkOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions/{subscriptionName}/marks",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentSubscriptionMarkCreateModel
    },
    400: {},
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentSubscriptionMarksOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions/{subscriptionName}/marks",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSubscriptionMarkModel"
            }
          }
        }
      }
    },
    400: {},
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var deleteAllDocumentSubscriptionMarksOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions/{subscriptionName}/marks",
  httpMethod: "DELETE",
  responses: {
    200: {},
    400: {},
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionName],
  serializer: serializer
};
var getDocumentSubscriptionMarkOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions/{subscriptionName}/marks/{markId}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentSubscriptionMarkModel
    },
    400: {},
    401: {},
    403: {},
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionName, Parameters.markId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var deleteDocumentSubscriptionMarkOperationSpec = {
  path: "/api/v1/portals/{portalId}/documentsubscriptions/{subscriptionName}/marks/{markId}",
  httpMethod: "DELETE",
  responses: {
    200: {},
    400: {},
    401: {},
    403: {},
    404: {},
    410: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionName, Parameters.markId],
  serializer: serializer
};